import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import { getCityName } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";


const VehicleDocExpiryDetails = () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token");

    const [VehicleDocExpiryDetailsApi, setVehicleDocExpiryDetailsApi] = useState([]);
    //const [searchVehicle, setSearchVehicle] = useState("");
    const [cities, setCities] = useState({});
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
    });

    const columns = [
        { field: "vehicleLicensePlate", headerName: "Vehicle Number", minWidth: 200 },
        { field: "vehicleName", headerName: "Vehicle Name", minWidth: 180 },
        {
            field: "cityId",
            headerName: "City Name",
            minWidth: 150,
            renderCell: (params) => cities[params?.value] || "-"
        },
        { field: "documentName", headerName: "Document Name", minWidth: 150 },
        { field: "documentType", headerName: "Document Type", minWidth: 150 },
        { field: "documentIdentificationNo", headerName: "Document ID No.", minWidth: 180 },
        { field: "expiryDate", headerName: "Expiry Date", minWidth: 180 },
        { field: "daysLeft", headerName: "Days Left", minWidth: 120 },
        { field: "expiryCategory", headerName: "Expiry Category", minWidth: 180 },
        {
            field: "criticality",
            headerName: "Criticality",
            minWidth: 150,
            renderCell: (params) => (
                <span style={{ color: params.row.cssColor }}>
                    {params.value}
                </span>
            ),
        }
    ];

    function createData(
        id,
        documentId,
        vehicleLicensePlate,
        vehicleName,
        cityId,
        documentName,
        documentType,
        documentIdentificationNo,
        expiryDate,
        daysLeft,
        expiryCategory,
        criticality,
        cssColor
    ) {
        return {
            id: documentId,
            documentId,
            vehicleLicensePlate,
            vehicleName,
            cityId,
            documentName,
            documentType,
            documentIdentificationNo,
            expiryDate,
            daysLeft,
            expiryCategory,
            criticality,
            cssColor,
        };
    }

    const rows = VehicleDocExpiryDetailsApi &&
        VehicleDocExpiryDetailsApi?.map((item) =>
            createData(
                item?.id,
                item?.documentId,
                item?.vehicleLicensePlate || "-",
                item?.vehicleName || "-",
                item?.cityId || "-",
                item?.documentName || "-",
                item?.documentType || "-",
                item?.documentIdentificationNo || "-",
                item?.expiryDate || "-",
                item?.daysLeft ?? 0,
                item?.expiryCategory || "-",
                item?.criticality || "-",
                item?.cssColor || "white"
            )
        ) || [];


    useEffect(() => {
        getVehicleDocExpiryDetails();
    }, [paginationModel.page, paginationModel.pageSize]);


    const getCitiesAPI = async () => {
        const apiDetails = await getCityName();
        const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
        if (data) {
            setCities(data);
        }
    };

    useEffect(() => {
        getCitiesAPI();
    }, []);

    const getVehicleDocExpiryDetails = async () => {
        if (!token) {
            return toast.error("Session Expired Close all the tab and signin again");
        }
        try {
            setLoading(true);

            const { page, pageSize } = paginationModel;
            const offset = page * pageSize;

            // const vehicleQuery = searchVehicle
            //     ? `&vehicleLicensePlate=${searchVehicle}`
            //     : "";

            const response = await fetch(
                `${apiUrl}/api/documents/vehicle-doc-expiry-details?limit=${pageSize}&offset=${offset}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        Authorization: `${token}`,
                    },
                }
            );

            const data = await response.json();

            if (data?.dataValues) {
                setVehicleDocExpiryDetailsApi(data.dataValues);
                setTotalCount(data.dataValues.length || 0);
            } else {
                setVehicleDocExpiryDetailsApi([]);
                setTotalCount(0);
            }
        } catch (error) {
            console.error("Error fetching vehicle document expiry details:", error);
            setVehicleDocExpiryDetailsApi([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ margin: "30px 0" }}>
            <div
                style={{
                    padding: "15px 20px",
                    fontSize: "20px",
                    fontWeight: "600",
                }}
            >
                Vehicle Documents Expiry Details
            </div>

            <Commongrid
                rows={rows}
                columns={columns}
                totalCount={totalCount}
                loading={loading}
                handleViewClick={() => { }}
                api={getVehicleDocExpiryDetails}
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                disableColumnMenu={true}
            />
        </div>
    );
};

export default VehicleDocExpiryDetails;